module.exports = __webpack_public_path__ + "img/pic_yangli.8e21a3ea.png";